import { FormControlLabel } from '@mui/material'
import { Stack } from '@mui/system'
import { ChangeEvent, useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable, DropResult } from '@hello-pangea/dnd'
import { EFDragIndicatorIcon } from '../EFIcons'
import { ButtonType, BUTTON_TYPE } from '../popups/DialogFooter/Button.model'
import { ITableSettingProps } from './EFTable.model'
import { DialogFooter } from '../popups'
import { EFCheckbox } from '../EFCheckbox'

export function TableSettingPopup({
  defaultHeadCells,
  headCells,
  onClose
}: ITableSettingProps) {
  const [displayedColumns, setDisplayedColumns] = useState(headCells)

  function handleChangeDislayedColumns(
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) {
    const itemIndex = displayedColumns.findIndex(item => item.id === event.target.name)

    if (itemIndex !== -1) {
      const updatedItems = [...displayedColumns]
      updatedItems[itemIndex] = { ...updatedItems[itemIndex], display: checked }

      setDisplayedColumns(updatedItems)
    }
  }

  const handleSubmit = (action: ButtonType) => {
    if (action === BUTTON_TYPE.APPLY) {
      onClose(displayedColumns)
      return
    }
    setDisplayedColumns(defaultHeadCells)
  }

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) return

    const items = [...displayedColumns]
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)

    setDisplayedColumns(items)
  }
  useEffect(() => {
    setDisplayedColumns(headCells)
  }, [headCells])

  return (
    <Stack
      direction='column'
      sx={{
        background: 'transparent',
        height: '100%'
      }}
    >
      <Stack px={3}>
        {displayedColumns
          .filter(column => column.isDragDisabled)
          .map(column => (
            <Stack
              key={column.id}
              direction='row'
              alignItems='center'
            >
              <Stack
                mr={1}
                sx={{ height: '1.3rem', width: '1.3rem' }}
              ></Stack>
              <FormControlLabel
                control={
                  <EFCheckbox
                    title={column.label}
                    name={column.id}
                    checked={column.display}
                    onChange={handleChangeDislayedColumns}
                  />
                }
                style={{ fontSize: '1.6rem' }}
                label={column.label}
              />
            </Stack>
          ))}
      </Stack>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId='displayedColumns'>
          {provided => (
            <Stack
              {...provided.droppableProps}
              ref={provided.innerRef}
              direction='column'
              padding={3}
              pt={0}
              pb={0}
              sx={{
                maxHeight: '30rem',
                overflow: 'auto',
                '& *': {
                  fontSize: '1rem !important'
                }
              }}
            >
              {displayedColumns.map((column, index) => {
                if (column.id !== '' && !column.isDragDisabled)
                  return (
                    <Draggable
                      key={column.id}
                      draggableId={column.id}
                      index={index}
                    >
                      {provided => (
                        <Stack
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          direction='row'
                          alignItems='center'
                        >
                          <Stack
                            mr={1}
                            sx={{ cursor: 'grab', height: '1.3rem', width: '1.3rem' }}
                          >
                            <EFDragIndicatorIcon />
                          </Stack>
                          <FormControlLabel
                            control={
                              <EFCheckbox
                                disableRipple
                                title={column.label}
                                name={column.id}
                                checked={column.display}
                                onChange={handleChangeDislayedColumns}
                              />
                            }
                            style={{ fontSize: '1.6rem' }}
                            label={column.label}
                          />
                        </Stack>
                      )}
                    </Draggable>
                  )
                return null
              })}
              {provided.placeholder}
            </Stack>
          )}
        </Droppable>
      </DragDropContext>
      <DialogFooter
        type='ApplyReset'
        onSubmit={handleSubmit}
      />
    </Stack>
  )
}
